import { 
    APRECOM_API_LOADING,
    APRECOM_DETAILS_ERROR,
    SAVE_APRECOM_DETAILS
   } from "../../constants/graphConstants/connectedClientsGraphConstants";
  
   export const aprecomDetailsReducer = (
     state = { 
        aprecomApiLoading : false,
        aprecomDetails : null,
        aprecomError: null
     }
     ,action
    ) => {
      switch (action.type) {
        case APRECOM_API_LOADING:
            return {
                ...state,
                aprecomApiLoading: action.payload,
            };
        case SAVE_APRECOM_DETAILS:
            return {
                ...state,
                aprecomApiLoading: false,
                aprecomDetails : action.payload,
            };
        case APRECOM_DETAILS_ERROR:
            return {
                ...state,
                aprecomApiLoading: false,
                aprecomError : action.payload,
            };
          default:
            return state;
        }
  }